/**
 * Research Leaders
 *
 * @returns {{init: init}}
 */
const ResearchLeaders = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.selectProfession = document.querySelector('select[name="filter-by-profession"]');
        DOM.selectSort = document.querySelector('select[name="sort-by-name"]');
        DOM.selectRegion = document.querySelector('select[name="filter-by-region"]');
        DOM.blockLeaders = document.querySelector('.block-leaders');
        DOM.clearButton = document.querySelector('.clear-button');
    };

    const handleApiResponse = (data, selectedProfession, selectedRegion, sortOption) => {
        // Filter the data based on the selected profession and region
        let filteredLeaders = data.filter(leader =>
            (selectedProfession === '' || leader.acf.profession === selectedProfession) &&
            (selectedRegion === '' || leader.acf.region === selectedRegion)
        );

        // Sort the filtered leaders by name if sort option is provided
        if (sortOption === 'ascend') {
            filteredLeaders.sort((a, b) => a.title.rendered.localeCompare(b.title.rendered));
        } else if (sortOption === 'descend') {
            filteredLeaders.sort((a, b) => b.title.rendered.localeCompare(a.title.rendered));
        }

        // Clear the blockLeaders element
        DOM.blockLeaders.innerHTML = '';

        if (filteredLeaders.length === 0) {
            const message = document.createElement('div');
            message.classList.add('block-multi', 'block-multi--equal', 'leaders-feed-no-results');
            message.textContent = 'No results found.';
            DOM.blockLeaders.appendChild(message);
            return; // Exit the function if no results are found
        }

        // Loop through the filtered leaders and generate HTML for each leader
        filteredLeaders.forEach(leader => {
            const leaderWrapper = document.createElement('div');
            leaderWrapper.classList.add('block-multi', 'block-multi--equal', 'leaders-feed-wrapper');

            const nameDiv = document.createElement('div');
            nameDiv.classList.add('name');
            nameDiv.textContent = leader.title.rendered;
            leaderWrapper.appendChild(nameDiv);

            const titleDiv = document.createElement('div');
            titleDiv.classList.add('title');
            titleDiv.textContent = leader.acf.professional_title;
            leaderWrapper.appendChild(titleDiv);

            const professionDiv = document.createElement('div');
            professionDiv.classList.add('profession');
            professionDiv.textContent = leader.acf.profession;
            leaderWrapper.appendChild(professionDiv);

            const employerDiv = document.createElement('div');
            employerDiv.classList.add('employer');
            employerDiv.textContent = leader.acf.employer;
            leaderWrapper.appendChild(employerDiv);

            const employer2Div = document.createElement('div');
            employer2Div.classList.add('employer2');
            employer2Div.textContent = leader.acf.employer2;
            leaderWrapper.appendChild(employer2Div);

            const regionDiv = document.createElement('div');
            regionDiv.classList.add('region');
            regionDiv.textContent = leader.acf.region;
            leaderWrapper.appendChild(regionDiv);

            const contactEmail = leader.acf.contact_email;
            const contactTwitter = leader.acf.contact_twitter;
            const contactOtherTitle = leader.acf.contact_other_title;
            const contactOtherLink = leader.acf.contact_other_link;
            const contactType = leader.acf.contact_type;

            if (contactType === 'request') {
                const requestDiv = document.createElement('div');
                requestDiv.classList.add('request');
                const requestLink = document.createElement('a');
                requestLink.href = '#linktoform';
                requestLink.textContent = 'Available on Request';
                requestDiv.appendChild(requestLink);
                leaderWrapper.appendChild(requestDiv);
            } else {
                const contactDiv = document.createElement('div');
                contactDiv.classList.add('contact-details');

                if (contactEmail) {
                    const emailDiv = document.createElement('div');
                    emailDiv.classList.add('email');
                    const emailLink = document.createElement('a');
                    emailLink.href = 'mailto:' + contactEmail;
                    emailLink.textContent = 'Email';
                    emailDiv.appendChild(emailLink);
                    contactDiv.appendChild(emailDiv);
                }
                if (contactTwitter) {
                    const twitterDiv = document.createElement('div');
                    twitterDiv.classList.add('twitter');
                    const twitterLink = document.createElement('a');
                    twitterLink.href = contactTwitter;
                    twitterLink.textContent = 'Twitter / X';
                    twitterLink.target = '_blank';
                    twitterLink.title = 'opens in a new window';
                    twitterDiv.appendChild(twitterLink);
                    contactDiv.appendChild(twitterDiv);
                }
                if (contactOtherTitle && contactOtherLink) {
                    const otherDiv = document.createElement('div');
                    otherDiv.classList.add('other');
                    const otherLink = document.createElement('a');
                    otherLink.href = contactOtherLink;
                    otherLink.textContent = contactOtherTitle;
                    otherLink.target = '_blank';
                    otherLink.title = 'opens in a new window';
                    otherDiv.appendChild(otherLink);
                    contactDiv.appendChild(otherDiv);
                }

                leaderWrapper.appendChild(contactDiv);
            }


            // Append the leader wrapper to the blockLeaders element
            DOM.blockLeaders.appendChild(leaderWrapper);
        });
    };

    const handleApiResponseSort = (data, sortOption) => {
        // Sort the entire dataset by name if sort option is provided
        if (sortOption === 'ascend') {
            data.sort((a, b) => a.title.rendered.localeCompare(b.title.rendered));
        } else if (sortOption === 'descend') {
            data.sort((a, b) => b.title.rendered.localeCompare(a.title.rendered));
        }

        // Clear the blockLeaders element
        DOM.blockLeaders.innerHTML = '';

        if (data.length === 0) {
            const message = document.createElement('div');
            message.classList.add('block-multi', 'block-multi--equal', 'leaders-feed-no-results');
            message.textContent = 'No results found.';
            DOM.blockLeaders.appendChild(message);
            return; // Exit the function if no results are found
        }

        // Loop through the sorted leaders and generate HTML for each leader
        data.forEach(leader => {
            const leaderWrapper = document.createElement('div');
            leaderWrapper.classList.add('block-multi', 'block-multi--equal', 'leaders-feed-wrapper');

            const nameDiv = document.createElement('div');
            nameDiv.classList.add('name');
            nameDiv.textContent = leader.title.rendered;
            leaderWrapper.appendChild(nameDiv);

            const titleDiv = document.createElement('div');
            titleDiv.classList.add('title');
            titleDiv.textContent = leader.acf.professional_title;
            leaderWrapper.appendChild(titleDiv);

            const professionDiv = document.createElement('div');
            professionDiv.classList.add('profession');
            professionDiv.textContent = leader.acf.profession;
            leaderWrapper.appendChild(professionDiv);

            const employerDiv = document.createElement('div');
            employerDiv.classList.add('employer');
            employerDiv.textContent = leader.acf.employer;
            leaderWrapper.appendChild(employerDiv);

            const employer2Div = document.createElement('div');
            employer2Div.classList.add('employer2');
            employer2Div.textContent = leader.acf.employer2;
            leaderWrapper.appendChild(employer2Div);

            const regionDiv = document.createElement('div');
            regionDiv.classList.add('region');
            regionDiv.textContent = leader.acf.region;
            leaderWrapper.appendChild(regionDiv);

            const contactEmail = leader.acf.contact_email;
            const contactTwitter = leader.acf.contact_twitter;
            const contactOtherTitle = leader.acf.contact_other_title;
            const contactOtherLink = leader.acf.contact_other_link;
            const contactType = leader.acf.contact_type;

            if (contactType === 'request') {
                const requestDiv = document.createElement('div');
                requestDiv.classList.add('request');
                const requestLink = document.createElement('a');
                requestLink.href = '#linktoform';
                requestLink.textContent = 'Available on Request';
                requestDiv.appendChild(requestLink);
                leaderWrapper.appendChild(requestDiv);
            } else {
                const contactDiv = document.createElement('div');
                contactDiv.classList.add('contact-details');

                if (contactEmail) {
                    const emailDiv = document.createElement('div');
                    emailDiv.classList.add('email');
                    const emailLink = document.createElement('a');
                    emailLink.href = 'mailto:' + contactEmail;
                    emailLink.textContent = 'Email';
                    emailDiv.appendChild(emailLink);
                    contactDiv.appendChild(emailDiv);
                }
                if (contactTwitter) {
                    const twitterDiv = document.createElement('div');
                    twitterDiv.classList.add('twitter');
                    const twitterLink = document.createElement('a');
                    twitterLink.href = contactTwitter;
                    twitterLink.textContent = 'Twitter / X';
                    twitterLink.target = '_blank';
                    twitterLink.title = 'opens in a new window';
                    twitterDiv.appendChild(twitterLink);
                    contactDiv.appendChild(twitterDiv);
                }
                if (contactOtherTitle && contactOtherLink) {
                    const otherDiv = document.createElement('div');
                    otherDiv.classList.add('other');
                    const otherLink = document.createElement('a');
                    otherLink.href = contactOtherLink;
                    otherLink.textContent = contactOtherTitle;
                    otherLink.target = '_blank';
                    otherLink.title = 'opens in a new window';
                    otherDiv.appendChild(otherLink);
                    contactDiv.appendChild(otherDiv);
                }

                leaderWrapper.appendChild(contactDiv);
            }


            // Append the leader wrapper to the blockLeaders element
            DOM.blockLeaders.appendChild(leaderWrapper);
        });
    };

    const handleApiResponseNoFilter = (data) => {
        // Clear the blockLeaders element
        DOM.blockLeaders.innerHTML = '';

        // Loop through all research leaders and generate HTML for each leader
        data.forEach(leader => {
            const leaderWrapper = document.createElement('div');
            leaderWrapper.classList.add('block-multi', 'block-multi--equal', 'leaders-feed-wrapper');

            const nameDiv = document.createElement('div');
            nameDiv.classList.add('name');
            nameDiv.textContent = leader.title.rendered;
            leaderWrapper.appendChild(nameDiv);

            const titleDiv = document.createElement('div');
            titleDiv.classList.add('title');
            titleDiv.textContent = leader.acf.professional_title;
            leaderWrapper.appendChild(titleDiv);

            const professionDiv = document.createElement('div');
            professionDiv.classList.add('profession');
            professionDiv.textContent = leader.acf.profession;
            leaderWrapper.appendChild(professionDiv);

            const employerDiv = document.createElement('div');
            employerDiv.classList.add('employer');
            employerDiv.textContent = leader.acf.employer;
            leaderWrapper.appendChild(employerDiv);

            const employer2Div = document.createElement('div');
            employer2Div.classList.add('employer2');
            employer2Div.textContent = leader.acf.employer2;
            leaderWrapper.appendChild(employer2Div);

            const regionDiv = document.createElement('div');
            regionDiv.classList.add('region');
            regionDiv.textContent = leader.acf.region;
            leaderWrapper.appendChild(regionDiv);

            const contactEmail = leader.acf.contact_email;
            const contactTwitter = leader.acf.contact_twitter;
            const contactOtherTitle = leader.acf.contact_other_title;
            const contactOtherLink = leader.acf.contact_other_link;
            const contactType = leader.acf.contact_type;

            if (contactType === 'request') {
                const requestDiv = document.createElement('div');
                requestDiv.classList.add('request');
                const requestLink = document.createElement('a');
                requestLink.href = '#linktoform';
                requestLink.textContent = 'Available on Request';
                requestDiv.appendChild(requestLink);
                leaderWrapper.appendChild(requestDiv);
            } else {
                const contactDiv = document.createElement('div');
                contactDiv.classList.add('contact-details');

                if (contactEmail) {
                    const emailDiv = document.createElement('div');
                    emailDiv.classList.add('email');
                    const emailLink = document.createElement('a');
                    emailLink.href = 'mailto:' + contactEmail;
                    emailLink.textContent = 'Email';
                    emailDiv.appendChild(emailLink);
                    contactDiv.appendChild(emailDiv);
                }
                if (contactTwitter) {
                    const twitterDiv = document.createElement('div');
                    twitterDiv.classList.add('twitter');
                    const twitterLink = document.createElement('a');
                    twitterLink.href = contactTwitter;
                    twitterLink.textContent = 'Twitter / X';
                    twitterLink.target = '_blank';
                    twitterLink.title = 'opens in a new window';
                    twitterDiv.appendChild(twitterLink);
                    contactDiv.appendChild(twitterDiv);
                }
                if (contactOtherTitle && contactOtherLink) {
                    const otherDiv = document.createElement('div');
                    otherDiv.classList.add('other');
                    const otherLink = document.createElement('a');
                    otherLink.href = contactOtherLink;
                    otherLink.textContent = contactOtherTitle;
                    otherLink.target = '_blank';
                    otherLink.title = 'opens in a new window';
                    otherDiv.appendChild(otherLink);
                    contactDiv.appendChild(otherDiv);
                }

                leaderWrapper.appendChild(contactDiv);
            }


            // Append the leader wrapper to the blockLeaders element
            DOM.blockLeaders.appendChild(leaderWrapper);
        });
    };

    const fetchAndFilterLeaders = () => {
        const selectedProfession = DOM.selectProfession.value;
        const selectedRegion = DOM.selectRegion.value;
        const sortOption = DOM.selectSort.value;

        //fetch('https://cahpr.test/wp-json/wp/v2/research_leaders')
        fetch('https://cahpr.org.uk/wp-json/wp/v2/research_leaders?per_page=100')
            .then(response => response.json())
            .then(data => {
                handleApiResponse(data, selectedProfession, selectedRegion, sortOption);
            })
            .catch(error => {
                console.error('Error fetching leaders:', error);
            });
    };

    const fetchAndSortLeaders = () => {
        const sortOption = DOM.selectSort.value;

        //fetch('https://cahpr.test/wp-json/wp/v2/research_leaders')
        fetch('https://cahpr.org.uk/wp-json/wp/v2/research_leaders?per_page=100')
            .then(response => response.json())
            .then(data => {
                handleApiResponseSort(data, sortOption);
            })
            .catch(error => {
                console.error('Error fetching leaders:', error);
            });
    };

    const fetchAllLeaders = () => {
        //fetch('https://cahpr.test/wp-json/wp/v2/research_leaders')
        fetch('https://cahpr.org.uk/wp-json/wp/v2/research_leaders?per_page=100')
            .then(response => response.json())
            .then(data => {
                handleApiResponseNoFilter(data);
            })
            .catch(error => {
                console.error('Error fetching leaders:', error);
            });
    };

    const clearButtonClickHandler = () => {
        // Clear all select fields
        DOM.selectProfession.value = '';
        DOM.selectSort.value = '';
        DOM.selectRegion.value = '';

        // Fetch all leaders
        fetchAllLeaders();
    };

    const bindEvents = () => {
        DOM.selectProfession.addEventListener('change', fetchAndFilterLeaders);
        DOM.selectRegion.addEventListener('change', fetchAndFilterLeaders);
        DOM.selectSort.addEventListener('change', fetchAndFilterLeaders);
        DOM.clearButton.addEventListener('click', clearButtonClickHandler);
    };

    const init = () => {
        cacheDOM();
        bindEvents();
        fetchAllLeaders();
    };

    return {
        init: init
    };
})();

export default ResearchLeaders;
